/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Chip, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from '../../constants/Constants';

/**
 * region for styles*/
import { listChipAttributesStyle } from './style/listChipAttributesStyle';

class ListChipAttributes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attributes: [],
            attributesFound: []
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            attributes: nextProps.items
        });
    }

    handleDeleteAttributes(deletedAttributes, event) {
        let self = this;
        let requestData = {
            Id: self.props.keyword.IDKEYWORD,
            IdRelated: deletedAttributes.IDATTRIBUTE
        };
        ajax.delete(Constants.ROUTE_API_ATTRIBUTES_DELETE_KEYWORD_ATTRIBUTE,
            {
                requestData: requestData,
                success: function (response) {
                    let attributes = []
                    response.data.forEach(function (item) {
                        let Attributes = { IDATTRIBUTE: item.IDATTRIBUTE, ATTRIBUTE: item.ATTRIBUTE };
                        attributes.push(Attributes)
                    })
                    self.setState({ attributes: attributes });
                }
            });
    }

    componentDidMount() {
        this.handleSugestAttributes(this,'');
    }

    handleAddAttributes(event, values) {
        let self = this;
        let newArrayIdAttributes = [];
        for (var index in values) {
            if (values[index].IDATTRIBUTE > 0) {
                newArrayIdAttributes.push(values[index].IDATTRIBUTE);
            }
        }

        let requestData = {
            Id: self.props.keyword.IDKEYWORD,
            IdList: newArrayIdAttributes
        };

        ajax.post(Constants.ROUTE_API_ATTRIBUTES_INSERT_KEYWORD_ATTRIBUTE,
            {
                requestData: requestData,
                success: function (response) {
                    if (response.data.length > 0) {
                        let attributes = []
                        response.data.forEach(function (item) {
                            let Attributes = { IDATTRIBUTE: item.IDATTRIBUTE, ATTRIBUTE: item.ATTRIBUTE };
                            attributes.push(Attributes)
                        })
                        self.setState({ attributes: attributes });
                    }
                }
            });
    }

    handleSugestAttributes(event, values) {
        let self = this;
        let text = values;
        let requestdata = {
            term: text
        };
        ajax.get(Constants.ROUTE_API_ATTRIBUTES_AUTOCOMPLETE,
            {
                requestData: requestdata,
                success: function (response) {
                    self.setState({ attributesFound: response.data })
                }
            });
    }

    render() {
        let self = this;
        const { classes } = this.props;
        return (
            <div className={classes.paddingDetails}>
                <Typography className={classes.subtitle2}
                    variant="body2"
                    display="block">
                    <strong>{this.props.title}</strong>
                </Typography>
                <Autocomplete
                    multiple
                    id="tags-outlined"
                    options={self.state.attributesFound}
                    getOptionLabel={option => option.ATTRIBUTE}
                    value={self.state.attributes}
                    filterSelectedOptions
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                        />
                    )}
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                className={classes.chipSpace}
                                key={option.IDATTRIBUTE}
                                label={option.ATTRIBUTE}
                                onDelete={this.handleDeleteAttributes.bind(this, option)} />
                        ))
                    }
                    onChange={this.handleAddAttributes.bind(this)}
                    onInputChange={this.handleSugestAttributes.bind(this)}
                />
            </div>
        );
    }
}
ListChipAttributes.propTypes = {
    classes: PropTypes.object.isRequired,
    items: PropTypes.array.isRequired
};
export default withStyles(listChipAttributesStyle)(ListChipAttributes);





